import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  // CLOCK_TYPE,
  ITime
} from '../w-clock/w-clock.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { WTimeComponent } from '../w-time/w-time.component';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    styleUrls: ['./w-time-dialog.component.scss'],
    templateUrl: './w-time-dialog.component.html',
    imports: [CdkScrollable, MatDialogContent, WTimeComponent, MatDialogModule]
})
export class WTimeDialogComponent {
  public userTime: ITime;
  public color: string | null;
  // private VIEW_HOURS = CLOCK_TYPE.HOURS;
  // private VIEW_MINUTES = CLOCK_TYPE.MINUTES;
  // private currentView: CLOCK_TYPE = this.VIEW_HOURS;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: {
      time: ITime;
      color: string | null;
    },
    private dialogRef: MatDialogRef<WTimeDialogComponent>
  ) {
    this.userTime = data.time;
    this.color = data.color;
  }

  public revert() {
    this.dialogRef.close(-1);
  }

  public submit() {
    this.dialogRef.close(this.userTime);
  }
}
